import React from "react";
import { useSelector } from "react-redux";

const useGetVisibleFor = () => {
  const { id } = useSelector(state => state.auth);

  const allowedList = [
    51103,
  ];

  return allowedList.includes(id);
}

export default useGetVisibleFor;